export default {"src":"/_next/static/media/tic-tac-toe.9c631530.gif","height":504,"width":752};